'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /~/react/react.js
// module id = 147
// module chunks = 0